// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_DeleteInput — body for POST /franchisor-channels/delete.
 *
 * Refused 'channel_has_enabled_bindings' by the controller when any
 * ENABLED franchisor_channel_triggers row still points at this channel —
 * deleting it out from under a live binding would silently orphan that
 * binding (channel_missing at notify time) instead of the staff seeing why.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_DeleteInput {
id: number
}

registerContract('FranchisorChannels_DeleteInput', {
  id: { type: 'number',  required: true },
})
